import { Instagram, LinkedIn } from '@mui/icons-material';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import { Link } from 'react-router-dom'
// import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';

export default function RedesSociasFooter() {
    return (
        <div className="tw-flex tw-items-center tw-p-5">

            <nav className="tw-flex tw-flex-col tw-gap-3">
                <a href={'https://www.facebook.com/ARMED.Angola/'} target={'_blank'} rel="noreferrer" className="tw-mr-2 tw-ml-2 tw-no-underline tw-text-[#85287e] tw-transition-colors hover:tw-text-[#eaa925]">
                    <FacebookRoundedIcon />
                </a>

                <a href={'https://www.instagram.com/armed_angola/'} target={'_blank'} rel="noreferrer" className="tw-mr-2 tw-ml-2 tw-no-underline tw-text-[#85287e] tw-transition-colors hover:tw-text-[#eaa925]">
                    <Instagram />
                </a>

                <a href={'https://www.linkedin.com/company/96306438/admin/feed/posts/'} target={'_blank'} rel="noreferrer" className="tw-mr-2 tw-ml-2 tw-no-underline tw-text-[#85287e] tw-transition-colors hover:tw-text-[#eaa925]">
                    <LinkedIn />
                </a>
            </nav>

            <div className="tw-p-2.5 tw-text-[#85287e] tw-text-[13px] tw-leading-[1.5] tw-border-l-2 tw-border-[#85287e] tw-ml-4">
                <p>Tel. (+244) 945 817 227</p>
                <p>expediente@armed.gov.ao | www.armed.gov.ao</p>
                <p>Rua Cmdt. Che-Guevara N° 86/86A,</p>
                <p>Maculusso, Luanda - Angola</p>
                <Link to={'/politicas-e-servicos'} className="tw-ml-0 tw-no-underline tw-text-[#85287e] tw-transition-colors hover:tw-text-[#eaa925]"> <b>Regras, politicas e serviços</b></Link>
            </div>
        </div>
    )
}